"use client";

import { useCallback, useMemo } from "react";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { usePathname } from "next/navigation";
import { usePersistState } from "@/hooks/usePersistState";
import spindl from "@spindl-xyz/attribution";
import { trackAnalyticsEvent, trackPageView } from "@/utils/analytics";

export default function useAnalytics() {
  const [isAttributed, setIsAttributed] = usePersistState<boolean>("spindl-attributed", false);

  const { primaryWallet } = useDynamicContext();
  const currentPath = usePathname();
  const address = useMemo(() => primaryWallet?.address, [primaryWallet]);

  const trackWalletConnect = useCallback(
    (address: string | undefined) => {
      if (address && !isAttributed) {
        // Attribute using Spindl native SDK
        spindl.attribute(address).then();
        // Track wallet connection when attributed
        setIsAttributed(true);

        trackAnalyticsEvent("wallet_connected", {}, { address });
      }
    },
    [isAttributed, setIsAttributed]
  );

  return useCallback(() => {
    trackWalletConnect(address);
    if (currentPath) {
      trackPageView(currentPath, address);
    }
  }, [address, currentPath, trackWalletConnect]);
}
